import http from "../../services/http";

const addCurriculoUsuario = async (formData) => {
  return await http("post", `v1/autenticacao/cadastrar`, formData, "multipart/form-data");
};

const handleLogin = async (formData) => {
  return await http("post", "v1/autenticacao/login", formData);
};

const requestRecuperacaoSenha = async (formData) => {
  return await http("post", "v1/autenticacao/solicitar_recuperacao", formData);
};

const changeRecuperacaoSenha = async (formData) => {
  return await http("post", "v1/autenticacao/recuperar_senha", formData);
};

const handleLogout = async () => {
  return await http("post", "v1/autenticacao/logout", []);
};

export { addCurriculoUsuario, handleLogin, requestRecuperacaoSenha, changeRecuperacaoSenha, handleLogout };
